import { AxiosError, AxiosRequestConfig } from 'axios';
import { useQuery } from 'react-query';

import { Api, GetFAQResponse } from '~api/api';
import { bootstrapConfig } from '~src/config/bootstrap-config';
import { bundledConfig } from '~src/config/bundled-config';
import { CountryConfig } from '../widget/widget-init';

export const axiosConfig: AxiosRequestConfig = {
  baseURL: `${bundledConfig.apiUrl}/v1/faq`,
  headers: {
    'x-auth-token': bootstrapConfig.auth_token,
  },
};

export const apiInstance = new Api(axiosConfig);

export function useGlobalStateQuery(countryConfig: CountryConfig) {
  return useQuery<GetFAQResponse, AxiosError>({
    queryKey: ['global-state', countryConfig],
    queryFn: async () => {
      const { data } = await apiInstance.faq.faqGet({
        country: countryConfig.country,
        currency: countryConfig.currency,
        locale: bootstrapConfig.locales[0],
      });
      return data;
    },
  });
}
